import { Row } from '../layout';
export default Row;



// WEBPACK FOOTER //
// ./_antd1.11.2/row/index.js